import React, { useEffect }  from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import QuestionnaireUserTable from '../questionnaireUser/QuestionnaireUserTable';
import QuestionnaireUserSearch from '../questionnaireUser/QuestionnaireUserSearch';
import Pagination from '@material-ui/lab/Pagination';
import { Grid } from '@material-ui/core';

const styles = () => ({
    paper: {
        width: '95%',
        margin: '5px 5px 5px 50px',
    },
    paging: {
        marginTop: '20px',
        marginBottom: '20px'
    },
});

const displayNum = 20; //1ページあたりの項目数

const defaultHeadCells = [
    { id: 'check', numeric: false, disablePadding: false, label: '', width: 'auto', textAlign: 'left', displayFlg: true},
    { id: 'recordId', numeric: false, disablePadding: false, label: 'レコード番号', width: 'auto', textAlign: 'left', displayFlg: true},
    { id: 'creationTime', numeric: false, disablePadding: false, label: '回答日時', width: 'auto', textAlign: 'left', displayFlg: true},
    { id: 'userId', numeric: false, disablePadding: false, label: 'ユーザーID', width: 'auto', textAlign: 'left', displayFlg: true },
    { id: 'entity1', numeric: false, disablePadding: false, label: '', width: 'auto', textAlign: 'left', displayFlg: false },
    { id: 'entity2', numeric: false, disablePadding: false, label: '', width: 'auto', textAlign: 'left', displayFlg: false },
    { id: 'entity3', numeric: false, disablePadding: false, label: '', width: 'auto', textAlign: 'left', displayFlg: false },
    { id: 'entity4', numeric: false, disablePadding: false, label: '', width: 'auto', textAlign: 'left', displayFlg: false },
    { id: 'entity5', numeric: false, disablePadding: false, label: '', width: 'auto', textAlign: 'left', displayFlg: false },
    { id: 'url', numeric: false, disablePadding: false, label: '詳細', width: 'auto', textAlign: 'left', displayFlg: true },
];

const QuestionnaireUser = (props) => {
    const { classes, userData, setUserData } = props;
    const [page, setPage] = React.useState(1); //ページ番号
    const [pageCount, setPageCount] = React.useState(); //ページ数
    const [allItems, setAllItems] = React.useState([]); //全データ
    const [displayedItems, setDisplayedItems] = React.useState([]); //表示データ
    const [allUpdate, setAllUpdate] = React.useState(false);
    //スピナー表示用
    const [isLoading, setIsLoading] = React.useState(false);
    //テーブルに表示する項目
    const [headCells, setHeadCells] = React.useState([]);

    useEffect(() => {
        //検索時は1ページ目に戻る
        setPage(1);
        setAllItems(userData);
        //ページカウントの計算
        setPageCount(Math.ceil(userData.length / displayNum));
        //表示データを抽出
        setDisplayedItems(userData.slice(0, displayNum));
        if(userData.length === 0 ) setAllUpdate(false);
        else{
            let headCellIndex = 4;
            console.log(defaultHeadCells);
            const copyHeadCells = defaultHeadCells.map(cell => ({ ...cell }));
            for(let i = 0; i < userData[0].additionalTableData.length; i++){
                //headCellのIndex4～8が可変専用のため
                if(headCellIndex <= 8){
                    copyHeadCells[headCellIndex].displayFlg = true;
                    copyHeadCells[headCellIndex].label = userData[0].additionalTableData[i].headerName;
                    headCellIndex++;
                }
            }
            setHeadCells(copyHeadCells);
        }
    }, [userData]);

    const handleChange = (event, index) => {
        //ページ移動時にページ番号を更新
        setPage(index);
        //ページ移動時に表示データを書き換える
        setDisplayedItems(allItems.slice(((index - 1) * displayNum), index * displayNum));
    };

    return (
        <React.Fragment>
            <div elevation={3} className={classes.paper} >
                <QuestionnaireUserSearch
                    setData={setUserData}
                    setAllUpdate={setAllUpdate}
                    setIsLoading={setIsLoading}
                />
                <QuestionnaireUserTable
                    datas={displayedItems}
                    allData={allItems}
                    setData={setUserData}
                    allUpdate={allUpdate}
                    setAllUpdate={setAllUpdate}
                    isLoading={isLoading}
                    headCells={headCells}
                />
                <Grid container item justifyContent="center" alignItems="center" className={classes.paging}>
                    <Pagination count={pageCount} page={page} size="large" color="primary" onChange={handleChange} />
                </Grid>
            </div>
        </React.Fragment>
    );
};

QuestionnaireUser.propTypes = {
    classes: PropTypes.object.isRequired,
    setUserData: PropTypes.func.isRequired,
    userData: PropTypes.array.isRequired,
};


export default withStyles(styles)(QuestionnaireUser);